import * as React from 'react'
import * as styles from './ToggleButton.module.scss'
import MUIToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { Controller, useFormContext } from 'react-hook-form'

export const ToggleButton = ({
  name,
  label,
  required,
  register,
  options,
  disabled,
  ...props
}) => {
  const { control, setValue: setFieldValue, getFieldState } = useFormContext()

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{ required: required && 'This field is required' }}
        render={({ field, fieldState: { error } }) => {
          return (
            <ToggleButtonGroup
              {...field}
              fullWidth
              color="primary"
              exclusive
              onChange={(event, value) => {
                setFieldValue(field.name, value)
              }}
              disabled={disabled}
            >
              {options.map(option => (
                <MUIToggleButton
                  className={styles.toggleButton}
                  classes={{
                    root: styles.toggleButtonRoot,
                    selected: styles.toggleButtonSelected,
                  }}
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </MUIToggleButton>
              ))}
            </ToggleButtonGroup>
          )
        }}
      />
      {getFieldState(name).error && (
        <p style={{ color: 'red', fontSize: '0.875rem', marginTop: '4px' }}>
          {getFieldState(name).error.message}
        </p>
      )}
    </>
  )
}
